import React, { Component } from "react"
import { Row, Col } from "elemental"
import { browserHistory } from "react-router"
import Responsive from "react-responsive"
import Filter from "../components/Filter/Filter"
import ProductCol5 from "../components/Product/ProductColDetail"
import SearchBar from "../components/Search/SearchBar"
import shop from "shop/shop"
import app from "app.controller"

export default class SearchPage extends Component {
  constructor( props ) {
    super()
    this.state = {
      search:   props.location.query.q || "", products: [], filter: {
        total: 12, pageSize: shop.settings.get( "pageSize" ), currentPage: 1,
      }, query: {
        page: props.location.query.page || 1, count: props.location.query.count || 10,
      }
    }
    this.load()
    app.search.change.add( this.handleSearch )
  }

  componentWillReceiveProps( props ) {
    let query = this.state.query
    let propQuery = props.location.query
    if ( propQuery.q !== query.q ) {
      this.setState( { search: propQuery.q, query: propQuery }, this.load )
    }
  }

  handleSearch = ( e = {} ) => {
    let query = ""
    if ( e.target && e.target.value ) query = e.target.value
    if ( e.q ) query = e.q

    this.setState( { search: query }, () => {
      if ( query.length >= 3 ) {
        this.load()
      }
    } )
  }

  onChangeFilter = ( filter ) => {
    this.updateQuery( filter )
  }

  addQuery( query ) {
    browserHistory.replace( {
      pathname: "/search", query
    } )
    return query
  }

  updateQuery( { page, sort, pageSize } ) {
    let query = this.state.query
    query.page = page || query.page
    query.count = pageSize || query.count
    query.sort = sort || query.sort
    query.q = this.state.search

    this.addQuery( query )
    this.setState( { query }, () => {
      this.load()
    } )
  }

  load = () => {
    let { query } = this.state
    if ( this.state.search.length < 3 ) {
      return
    }
    if( this.lastSearch !== this.state.search) query.page =1

    this.lastSearch = this.state.search
    shop.products.search( this.state.search, {
      count: query.count,
      page: query.page,
      sort: query.sort,
      filter: false
    } )
      .then( response => {
        let { query } = this.state
        query.q = this.state.search
        let { products = [] } = response
        this.setState( {
          size: response.size, products
        } )
        this.addQuery( query )
      } )
  }

  componentWillUnmount() {
    app.search.change.remove( this.handleSearch )
  }

  render() {
    let filter = {
      currentPage: Number( this.state.query.page ), total: Number( this.state.size ), pageSize: Number( this.state.query.count ), brand: String( this.state.query.brand ),
      sort:        String( this.state.query.sort ) || "sort"
    }

    let filterSection = <section>
      <Filter onChange={this.onChangeFilter} {...filter} />
    </section>

    let products = this.state.products.map( product => <ProductCol5
      sm="1/2"
      key={product.map_id}
      product={product}/> )

    return (
      <div className="container mb pt4">

        <Responsive maxWidth={991}>
          <SearchBar/>
        </Responsive>

        <h3>Suche nach "{this.state.query.q}"</h3>

        <Row>
          <Col sm="1">
            {this.state.size > 0 ? filterSection : null}
            <section className="mb5">
              {this.state.size > 0 ? null : <div className="tc pa4">Keine Produkte gefunden</div>}
              <Row>
                {products}
              </Row>
            </section>
            {this.state.size > 0 ? filterSection : null}
          </Col>
        </Row>
      </div>
    )
  }
}

SearchPage.propTypes = {
  params: React.PropTypes.object, filter: React.PropTypes.object, location: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/pages/SearchPage.js